const buildBaseCandidates = () => {
  const candidates = [
    process.env.REACT_APP_RESOURCE_ENDPOINT,
    process.env.REACT_APP_RESOURCE_ENDPOINT,
  ].filter(Boolean);

  const apiBases = [
    process.env.REACT_APP_UAT_API_ENDPOINT,
    process.env.REACT_APP_API_ENDPOINT,
  ].filter(Boolean);
  apiBases.forEach((apiBase) => {
    const normalized = apiBase.replace(/\/api\/?$/, "/");
    candidates.push(normalized);
  });

  return Array.from(new Set(candidates));
};

const buildUrl = (base, path) =>
  `${base.replace(/\/+$/, "")}/${path.replace(/^\/+/, "")}`;

const tryFetchJson = async (url) => {
  const response = await fetch(url, {
    headers: { Accept: "application/json" },
  });
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }
  const contentType = response.headers.get("content-type") || "";
  const rawText = await response.text();
  if (!rawText) {
    throw new Error("Empty response body");
  }
  try {
    return JSON.parse(rawText);
  } catch (error) {
    if (contentType.includes("application/json")) {
      throw error;
    }
    throw new Error("Response is not valid JSON");
  }
};

const _fetchCategoriesService = async (setCategoriesList, setIsLoading) => {
  try {
    setIsLoading(true);
    const timestamp = new Date().getTime();
    const candidates = buildBaseCandidates();
    let data = null;

    for (const base of candidates) {
      const url = buildUrl(base, `Category.json?t=${timestamp}`);
      try {
        data = await tryFetchJson(url);
        break;
      } catch (error) {
        console.warn("Category.json fetch failed:", url, error.message);
      }
    }

    if (!data) {
      throw new Error("No category source returned JSON");
    }
    const businessName = process.env.REACT_APP_BUSINESS_NAME;
    let businessCategories =
      businessName && Array.isArray(data[businessName]) ? data[businessName] : null;

    if (!businessCategories && businessName) {
      const normalizeKey = (value) =>
        String(value || "")
          .toLowerCase()
          .replace(/[\s_-]+/g, "");
      const targetKey = normalizeKey(businessName);
      const matchedKey = Object.keys(data || {}).find(
        (key) => normalizeKey(key) === targetKey
      );
      if (matchedKey && Array.isArray(data[matchedKey])) {
        businessCategories = data[matchedKey];
      }
    }
    setCategoriesList(businessCategories || data.Categories || []); // Business-specific or fallback
  } catch (error) {
    console.error("Error fetching categories:", error);
  } finally {
    setIsLoading(false);
  }
};

const _fetchMarketingCategoriesService = async (setCategoriesList, setIsLoading) => {
  try {
    setIsLoading(true);
    const timestamp = new Date().getTime();
    const candidates = buildBaseCandidates();
    let data = null;

    for (const base of candidates) {
      const url = buildUrl(base, `MarketingCategory.json?t=${timestamp}`);
      try {
        data = await tryFetchJson(url);
        break;
      } catch (error) {
        console.warn("MarketingCategory.json fetch failed:", url, error.message);
      }
    }

    if (!data) {
      throw new Error("No marketing category source returned JSON");
    }

    const businessName = process.env.REACT_APP_BUSINESS_NAME;
    let marketingCategoryList = [];
    if (Array.isArray(data)) {
      const filtered = businessName
        ? data.filter(
            (item) => item?.businessName === businessName && item?.isActive === true
          )
        : data.filter((item) => item?.isActive === true);
      marketingCategoryList = filtered.map((item) => item?.title).filter(Boolean);
    } else if (Array.isArray(data?.Categories)) {
      marketingCategoryList = data.Categories;
    }
    setCategoriesList(marketingCategoryList);
  } catch (error) {
    console.error("Error fetching marketing categories:", error);
  } finally {
    setIsLoading(false);
  }
};

const _fetchColorService = async (setCategoriesList, setIsLoading) => {
  try {
    setIsLoading(true);

    // Append a cache-busting query parameter to the URL
    const timestamp = new Date().getTime();
    const url = `${process.env.REACT_APP_RESOURCE_ENDPOINT}/Color.json?t=${timestamp}`;

    const response = await fetch(url);
    const data = await response.json();
    setCategoriesList(data.Categories || []); // Assuming response format { Categories: [...] }
  } catch (error) { 
    console.error('Error fetching categories:', error);
  } finally {
    setIsLoading(false);
  }
};
export { _fetchCategoriesService, _fetchMarketingCategoriesService, _fetchColorService };
